import * as React from 'react';
import { Flat } from '../Flat';
import { FlatTooltip } from '../FlatTooltip';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Flats = function Flats(_ref) {
  var flats = _ref.flats,
    containerHeight = _ref.containerHeight,
    containerWidth = _ref.containerWidth,
    realWidth = _ref.realWidth,
    realHeight = _ref.realHeight,
    onFlatOpen = _ref.onFlatOpen,
    onFlatHover = _ref.onFlatHover,
    hoveredFlatPlanId = _ref.hoveredFlatPlanId;
  return /*#__PURE__*/_jsx("div", {
    className: style['flats'],
    style: {
      width: realWidth + 'px'
    },
    children: /*#__PURE__*/_jsx("div", {
      className: style['flats-inner'],
      style: {
        height: realHeight + 'px'
      },
      children: flats.map(function (flat) {
        if (!flat.polygon) {
          return null;
        }
        return /*#__PURE__*/_jsx(Flat, {
          id: flat.id,
          hoveredFlatPlanId: hoveredFlatPlanId,
          roomCount: flat.polygon.roomCount,
          name: flat.title,
          tooltipPoint: flat.polygon.tooltipPoint,
          polygonPath: flat.polygon.polygonPath,
          containerWidth: containerWidth,
          containerHeight: containerHeight,
          tooltip: /*#__PURE__*/_jsx(FlatTooltip, {
            flatId: flat.id,
            flatInfo: flat.description,
            price: flat.price,
            hasDecoration: flat.hasDecoration,
            onFlatOpen: onFlatOpen,
            similarOffersCount: flat.offer.similarOffersCount
          }),
          onFlatHover: onFlatHover,
          onFlatOpen: onFlatOpen
        }, flat.id);
      })
    })
  });
};